export const CLIENTS_PAGES = [
  {
    slug: "clients/investisseurs-prives",
    fr: {
      eyebrow: "Clients · Investisseurs privés",
      title: "Des solutions structurées pour le capital privé",
      intro:
        "Familles, fondateurs et investisseurs privés : une voie discrète pour la structuration du patrimoine, l'accès aux transactions privées, la succession et les décisions de capital transfrontalières.",
      chips: ["Confidentiel par conception", "Conseiller senior dédié"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Capacités conçues pour les investisseurs privés",
          sub: "L'infrastructure de conseil que les institutions considèrent comme acquise — adaptée à votre échelle.",
          items: [
            "Structures d'investissement transfrontalières sur mesure",
            "Accès aux transactions & co-investissements",
            "Architecture de portefeuille multi-juridictions",
            "Préservation de patrimoine & planification de succession",
            "Modèle d'engagement confidentiel et sur mesure",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Travaux typiques",
          items: [
            { title: "Acquisition d'un actif de rendement", desc: "De la recherche ciblée à la diligence complète et à la négociation, jusqu'à la signature." },
            { title: "Consolidation patrimoniale", desc: "Rassembler des actifs dispersés dans une architecture lisible, gouvernable et transmissible." },
            { title: "Préparation de succession", desc: "Anticiper la transmission trois ans en amont, pour que tout se déroule comme prévu." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Clients · Private investors",
      title: "Structured solutions for sophisticated capital",
      intro:
        "Families, founders and private investors: a discreet pathway for wealth structuring, private deal access, succession and cross-border capital decisions.",
      chips: ["Confidential by design", "Dedicated senior advisor"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Capabilities designed for private investors",
          sub: "The advisory infrastructure institutions take for granted — tailored to your scale.",
          items: [
            "Bespoke cross-border investment structures",
            "Deal access & co-investment opportunities",
            "Multi-jurisdiction portfolio architecture",
            "Wealth preservation & succession planning",
            "Confidential, bespoke engagement model",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Typical work",
          items: [
            { title: "Acquiring an income-producing asset", desc: "From targeted search to full diligence and negotiation, through to signature." },
            { title: "Wealth consolidation", desc: "Bringing scattered assets into a readable, governable, transferable architecture." },
            { title: "Succession preparation", desc: "Preparing the transfer three years ahead, so everything unfolds as planned." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Kunden · Privatinvestoren",
      title: "Strukturierte Lösungen für anspruchsvolles Kapital",
      intro:
        "Familien, Gründer und Privatinvestoren: ein diskreter Weg für Vermögensstrukturierung, Zugang zu privaten Transaktionen, Nachfolge und grenzüberschreitende Kapitalentscheidungen.",
      chips: ["Vertraulich von Konzept", "Dedizierter Senior-Berater"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Kapazitäten, gestaltet für Privatinvestoren",
          sub: "Die Beratungsinfrastruktur, die Institutionen als selbstverständlich betrachten — zugeschnitten auf Ihre Grösse.",
          items: [
            "Massgeschneiderte grenzüberschreitende Investmentstrukturen",
            "Deal-Zugang & Co-Investitionsmöglichkeiten",
            "Portfolio-Architektur über Jurisdiktionen",
            "Vermögenserhalt & Nachfolgeplanung",
            "Vertrauliches, massgeschneidertes Mandatsmodell",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Typische Arbeiten",
          items: [
            { title: "Erwerb einer Renditeliegenschaft", desc: "Von der gezielten Suche über die vollständige Prüfung bis zur Verhandlung und Unterschrift." },
            { title: "Vermögenskonsolidierung", desc: "Verstreute Vermögenswerte in einer lesbaren, steuerbaren und übertragbaren Architektur bündeln." },
            { title: "Nachfolgevorbereitung", desc: "Die Übertragung drei Jahre im Voraus vorbereiten — damit alles wie geplant verläuft." },
          ],
        },
      ],
    },
  },
  {
    slug: "clients/entreprises",
    fr: {
      eyebrow: "Clients · Entreprises",
      title: "Une exécution stratégique à l'échelle internationale",
      intro:
        "Croissance, structuration, financement, gouvernance : nous servons les entreprises à la fois comme conseil et comme partenaire de mise en œuvre.",
      chips: ["Conseil + exécution", "Mid-market & ETI"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Capacités conçues pour les entreprises",
          items: [
            "Entrée sur marché & expansion internationale",
            "Conseil M&A et accompagnement transactionnel",
            "Restructuration & optimisation sociétaire",
            "Solutions de financement transfrontalier",
            "Stratégie réglementaire & juridictionnelle",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Travaux typiques",
          items: [
            { title: "Expansion à l'international", desc: "Évaluer les juridictions, structurer l'implantation et coordonner les conseils locaux." },
            { title: "Transaction stratégique", desc: "Acquisition ou cession : préparation, valorisation, négociation et clôture." },
            { title: "Refinancement", desc: "Architecture de dette adaptée au cycle de croissance, négociée avec les bons partenaires." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Clients · Corporations",
      title: "Strategic execution at global scale",
      intro:
        "Growth, structuring, financing, governance: we serve companies as both advisor and implementation partner.",
      chips: ["Advisory + execution", "Mid-market focus"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Capabilities designed for corporations",
          items: [
            "Market entry & international expansion",
            "M&A advisory and transaction support",
            "Corporate restructuring and optimisation",
            "Cross-border financing solutions",
            "Regulatory and jurisdiction strategy",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Typical work",
          items: [
            { title: "International expansion", desc: "Assessing jurisdictions, structuring the setup and coordinating local counsel." },
            { title: "Strategic transaction", desc: "Acquisition or disposal: preparation, valuation, negotiation and closing." },
            { title: "Refinancing", desc: "Debt architecture adapted to the growth cycle, negotiated with the right partners." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Kunden · Unternehmen",
      title: "Strategische Umsetzung auf internationalem Niveau",
      intro:
        "Wachstum, Strukturierung, Finanzierung, Governance: Wir begleiten Unternehmen als Berater und als Umsetzungspartner.",
      chips: ["Beratung + Umsetzung", "Fokus Mid-Market"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Kapazitäten, gestaltet für Unternehmen",
          items: [
            "Markteintritt & internationale Expansion",
            "M&A-Beratung und Transaktionsbegleitung",
            "Gesellschaftsrestrukturierung und -optimierung",
            "Grenzüberschreitende Finanzierungslösungen",
            "Regulatorische & Jurisdiktionsstrategie",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Typische Arbeiten",
          items: [
            { title: "Internationale Expansion", desc: "Jurisdiktionen bewerten, die Niederlassung strukturieren und lokale Berater koordinieren." },
            { title: "Strategische Transaktion", desc: "Erwerb oder Veräusserung: Vorbereitung, Bewertung, Verhandlung und Abschluss." },
            { title: "Refinanzierung", desc: "Schuldenarchitektur passend zum Wachstumszyklus, verhandelt mit den richtigen Partnern." },
          ],
        },
      ],
    },
  },
  {
    slug: "clients/societes-cotees",
    fr: {
      eyebrow: "Clients · Sociétés cotées",
      title: "Gouvernance, conformité & engagement investisseurs",
      intro:
        "Émetteurs et sociétés cotées : une voie axée gouvernance pour les communications d'émetteur, les documents de conseil, la cartographie des parties prenantes et la préparation transactionnelle.",
      chips: ["Normes d'émetteur", "Multi-juridictions"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Capacités conçues pour les sociétés cotées",
          items: [
            "Structuration des relations investisseurs",
            "Conseil en déclarations & conformité réglementaire",
            "Assemblées annuelles & support de gouvernance",
            "Obligations d'émetteur transfrontalières",
            "Cadres de reporting ESG & durabilité",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Travaux typiques",
          items: [
            { title: "Programme de relations investisseurs", desc: "Rythme de publication, supports et messages alignés sur la stratégie." },
            { title: "Préparation de transaction", desc: "Documentation, gouvernance et communications avant une opération de marché." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Clients · Public companies",
      title: "Governance, compliance & investor engagement",
      intro:
        "Issuers and listed companies: a governance-led pathway for issuer communications, board materials, stakeholder mapping and transaction readiness.",
      chips: ["Issuer standards", "Multi-jurisdiction"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Capabilities designed for public companies",
          items: [
            "Investor relations structuring",
            "Regulatory filing and compliance advisory",
            "Annual meeting and governance support",
            "Cross-border issuer obligations",
            "ESG and sustainability reporting frameworks",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Typical work",
          items: [
            { title: "Investor relations programme", desc: "Publication rhythm, materials and messaging aligned with strategy." },
            { title: "Transaction readiness", desc: "Documentation, governance and communications ahead of a market operation." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Kunden · Kotierte Gesellschaften",
      title: "Governance, Compliance & Investorenbindung",
      intro:
        "Emittenten und kotierte Gesellschaften: ein governance-geführter Weg für Emittentenkommunikation, Verwaltungsratsunterlagen, Stakeholder-Mapping und Transaktionsbereitschaft.",
      chips: ["Emittenten-Standards", "Multi-Jurisdiktion"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Kapazitäten, gestaltet für kotierte Gesellschaften",
          items: [
            "Strukturierung der Investorenbeziehungen",
            "Beratung zu Meldungen & regulatorischer Compliance",
            "Generalversammlungen & Governance-Unterstützung",
            "Grenzüberschreitende Emittentenpflichten",
            "ESG- & Nachhaltigkeits-Reporting-Rahmen",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Typische Arbeiten",
          items: [
            { title: "Investor-Relations-Programm", desc: "Publikationsrhythmus, Unterlagen und Botschaften, auf die Strategie abgestimmt." },
            { title: "Transaktionsbereitschaft", desc: "Dokumentation, Governance und Kommunikation vor einer Marktoperation." },
          ],
        },
      ],
    },
  },
  {
    slug: "clients/fonds-institutions",
    fr: {
      eyebrow: "Clients · Fonds & institutions",
      title: "Un conseil de niveau institutionnel pour mandats complexes",
      intro:
        "Gérants d'actifs et investisseurs institutionnels : un partenaire avec la profondeur, la discrétion et la portée nécessaires pour sourcer, structurer et exécuter des mandats complexes.",
      chips: ["Véhicules & structures", "Origination"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Capacités conçues pour les fonds & institutions",
          items: [
            "Conception & structuration de véhicules d'investissement",
            "Origination & développement de pipeline",
            "Stratégie réglementaire & conformité",
            "Administration de fonds multi-juridictions",
            "Conseil aux sociétés de portefeuille",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Travaux typiques",
          items: [
            { title: "Création de véhicule", desc: "Structuration d'un fonds ou d'un SPV immobilier avec gouvernance et reporting intégrés." },
            { title: "Accès au deal flow", desc: "Pipeline d'opportunités qualifiées sur nos marchés suivis, avec pré-diligence." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Clients · Funds & institutions",
      title: "Institutional-grade advisory for complex mandates",
      intro:
        "Asset managers and institutional investors: a partner with the depth, discretion and reach to source, structure and execute complex mandates.",
      chips: ["Vehicles & structures", "Origination"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Capabilities designed for funds & institutions",
          items: [
            "Investment vehicle design and structuring",
            "Deal origination and pipeline development",
            "Regulatory and compliance strategy",
            "Cross-jurisdictional fund administration",
            "Portfolio company advisory support",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Typical work",
          items: [
            { title: "Vehicle creation", desc: "Structuring a real estate fund or SPV with integrated governance and reporting." },
            { title: "Deal flow access", desc: "Pipeline of qualified opportunities on our tracked markets, with pre-diligence." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Kunden · Fonds & Institutionen",
      title: "Beratung auf institutionellem Niveau für komplexe Mandate",
      intro:
        "Vermögensverwalter und institutionelle Investoren: ein Partner mit der Tiefe, Diskretion und Reichweite, um komplexe Mandate zu beschaffen, zu strukturieren und auszuführen.",
      chips: ["Vehikel & Strukturen", "Origination"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Kapazitäten, gestaltet für Fonds & Institutionen",
          items: [
            "Design & Strukturierung von Investmentvehikeln",
            "Deal-Origination & Pipeline-Aufbau",
            "Regulatorische & Compliance-Strategie",
            "Fondsadministration über Jurisdiktionen",
            "Beratung von Portfoliogesellschaften",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Typische Arbeiten",
          items: [
            { title: "Vehikel-Gründung", desc: "Strukturierung eines Immobilienfonds oder SPV mit integrierter Governance und Reporting." },
            { title: "Deal-Flow-Zugang", desc: "Pipeline qualifizierter Gelegenheiten auf unseren beobachteten Märkten, mit Vorprüfung." },
          ],
        },
      ],
    },
  },
  {
    slug: "clients/gestion-fortune",
    fr: {
      eyebrow: "Clients · Gestion de fortune",
      title: "Élever la gestion de fortune à l'ère moderne",
      intro:
        "Gestionnaires de fortune et conseillers : une voie de soutien à la pratique pour l'architecture de portefeuille, le reporting client, l'accès aux alternatifs et la coordination du conseil.",
      chips: ["Support de pratique", "Alternatifs"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Capacités conçues pour la gestion de fortune",
          items: [
            "Construction & optimisation de portefeuille",
            "Accès aux investissements alternatifs",
            "Structuration patrimoniale fiscalement efficiente",
            "Conseil en expérience client digitale",
            "Gestion de pratique & stratégie de croissance",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Travaux typiques",
          items: [
            { title: "Architecture de portefeuille", desc: "Cadre d'allocation intégrant l'immobilier direct et les actifs alternatifs." },
            { title: "Reporting client renforcé", desc: "Des relevés consolidés que vos clients comprennent — et apprécient." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Clients · Wealth management",
      title: "Elevating wealth management for the modern era",
      intro:
        "Wealth managers and advisers: a practice-support pathway for portfolio architecture, client reporting, alternative access and advisory coordination.",
      chips: ["Practice support", "Alternatives"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Capabilities designed for wealth management",
          items: [
            "Portfolio construction and optimisation",
            "Alternative investment access",
            "Tax-efficient wealth structuring",
            "Digital client experience advisory",
            "Practice management and growth strategy",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Typical work",
          items: [
            { title: "Portfolio architecture", desc: "Allocation framework integrating direct real estate and alternative assets." },
            { title: "Enhanced client reporting", desc: "Consolidated statements your clients understand — and appreciate." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Kunden · Vermögensverwaltung",
      title: "Vermögensverwaltung für die moderne Ära",
      intro:
        "Vermögensverwalter und Berater: ein Unterstützungsweg für Portfolio-Architektur, Kundenreporting, Zugang zu alternativen Anlagen und Beratungskoordination.",
      chips: ["Praxis-Unterstützung", "Alternative Anlagen"],
      sections: [
        {
          type: "list",
          theme: "light",
          title: "Kapazitäten, gestaltet für die Vermögensverwaltung",
          items: [
            "Portfolio-Konstruktion und -Optimierung",
            "Zugang zu alternativen Anlagen",
            "Steuereffiziente Vermögensstrukturierung",
            "Beratung zur digitalen Kundenerfahrung",
            "Praxismanagement & Wachstumsstrategie",
          ],
        },
        {
          type: "numbered",
          theme: "dark",
          title: "Typische Arbeiten",
          items: [
            { title: "Portfolio-Architektur", desc: "Allokationsrahmen mit direkten Immobilien und alternativen Anlagen." },
            { title: "Verbessertes Kundenreporting", desc: "Konsolidierte Ausweise, die Ihre Kunden verstehen — und schätzen." },
          ],
        },
      ],
    },
  },
];
